/*jslint browser: true, fudge: true, long: true */
/*global $, blacksunplc, dialogPolyfill, document, location, navigator, window */

blacksunplc.events.ready(function () {
    "use strict";

    var tablet = window.matchMedia("screen and (max-width: 880px)");

    $("#btnNavigation").on("click", function ( /** !jQuery.Event */ event) {
        event.preventDefault();
        $("body").addClass("menu-open");
    });

    // New mobile nav: close buttons
    $(".mobile-nav__close").on("click", function (event) {
        event.preventDefault();
        $("body").removeClass("menu-open subnav-active");
        $(".mobile-nav__secondary").removeClass("is-active");
    });

    // New mobile nav: main nav items open submenus
    $(".mobile-nav__primary button[data-subnav]").on("click", function (event) {
        event.preventDefault();
        const subnavType = $(this).data("subnav");
        $("body").addClass("subnav-active");
        $(".mobile-nav__secondary").removeClass("is-active");
        $(`.mobile-nav__secondary[data-panel="${subnavType}"]`).addClass("is-active");
    });

    // New mobile nav: back button returns to main menu
    $(".mobile-nav__back").on("click", function (event) {
        event.preventDefault();
        $("body").removeClass("subnav-active");
        $(".mobile-nav__secondary").removeClass("is-active");
    });

    $(".main-header__wrapper .container").on("click", function (event) {
        event.stopPropagation();
    });

    // Desktop Navigation behavior
    const desktopNav = document.querySelector(".desktop-nav");
    const desktopNavTop = desktopNav ? desktopNav.querySelector(".desktop-nav__top") : null;
    const revealThreshold = 50; // pixels to scroll before showing secondary nav
    const stickyThreshold = 126; // when secondary becomes sticky
    const mainNavHeight = 80; // height of main nav
    let defaultActiveSubnav = "platform"; // default subnav based on current page
    let lastActiveSubnav = "platform";
    let lastScrollY = window.scrollY;
    const isHomepage = document.body.classList.contains("homepage");

    if (desktopNav && desktopNavTop) {
        const navItems = desktopNav.querySelectorAll(".desktop-nav__item");
        const subnavs = desktopNav.querySelectorAll(".desktop-nav__secondary");

        // Set initial active subnav based on the active main nav item
        const activeNavItem = desktopNav.querySelector(".desktop-nav__item.active");
        if (activeNavItem && activeNavItem.dataset.nav) {
            defaultActiveSubnav = activeNavItem.dataset.nav;
            lastActiveSubnav = defaultActiveSubnav;
        }

        // Function to show a specific subnav
        function showSubnav(navType) {
            subnavs.forEach(function (subnav) {
                if (subnav.dataset.subnav === navType) {
                    subnav.classList.add("is-visible");
                } else {
                    subnav.classList.remove("is-visible");
                }
            });
            desktopNav.classList.add("has-active-subnav");
            lastActiveSubnav = navType;
        }

        // Function to hide all subnavs
        function hideAllSubnavs() {
            if (!desktopNav.classList.contains("is-scrolled") && !desktopNav.classList.contains("is-revealed")) {
                subnavs.forEach(function (subnav) {
                    subnav.classList.remove("is-visible");
                });
                desktopNav.classList.remove("has-active-subnav");
            }
        }

        // Hover events for main nav items
        navItems.forEach(function (item) {
            item.addEventListener("mouseenter", function () {
                const navType = this.dataset.nav;
                showSubnav(navType);
                // Highlight the hovered item
                navItems.forEach(function (i) { i.classList.remove("is-active"); });
                this.classList.add("is-active");
            });
        });

        // Mouse leave from the entire desktop nav
        desktopNav.addEventListener("mouseleave", function () {
            hideAllSubnavs();
            navItems.forEach(function (i) { i.classList.remove("is-active"); });

            // Reset to default subnav for the current page
            lastActiveSubnav = defaultActiveSubnav;
            if (desktopNav.classList.contains("is-scrolled") || desktopNav.classList.contains("is-revealed")) {
                showSubnav(defaultActiveSubnav);
            }
        });

        // Scroll behavior
        window.addEventListener("scroll", function () {
            const scrollY = window.scrollY;
            const isScrollingUp = scrollY < lastScrollY;

            if (isHomepage) {
                // Homepage behavior: hide on scroll down, show on scroll up
                // BUT skip sub-nav reveal logic (is-revealed, is-scrolled)
                desktopNav.classList.remove("is-revealed", "is-scrolled");

                if (scrollY > stickyThreshold) {
                    desktopNav.classList.add("is-scrolled-deep");

                    if (isScrollingUp) {
                        desktopNav.classList.add("is-showing-up");
                        desktopNavTop.style.marginTop = "0";
                    } else {
                        desktopNav.classList.remove("is-showing-up");
                        desktopNavTop.style.marginTop = "-" + mainNavHeight + "px";
                    }
                } else {
                    desktopNav.classList.remove("is-scrolled-deep");
                    desktopNav.classList.remove("is-showing-up");
                    desktopNavTop.style.marginTop = "0";
                }
            } else if (scrollY > stickyThreshold) {
                // Stage 2: Main nav slides up based on scroll, secondary follows naturally
                desktopNav.classList.add("is-scrolled");
                desktopNav.classList.add("is-revealed");
                showSubnav(lastActiveSubnav);

                // Deeply scrolled beyond the gradual hide area
                if (scrollY > stickyThreshold + mainNavHeight) {
                    desktopNav.classList.add("is-scrolled-deep");

                    if (isScrollingUp) {
                        desktopNav.classList.add("is-showing-up");
                        desktopNavTop.style.marginTop = "0";
                    } else {
                        desktopNav.classList.remove("is-showing-up");
                        desktopNavTop.style.marginTop = "-" + mainNavHeight + "px";
                    }
                } else {
                    desktopNav.classList.remove("is-scrolled-deep");
                    desktopNav.classList.remove("is-showing-up");
                    // Smoothly slide main nav up using margin (affects layout)
                    const slideAmount = Math.min(scrollY - stickyThreshold, mainNavHeight);
                    desktopNavTop.style.marginTop = "-" + slideAmount + "px";
                }

            } else if (scrollY > revealThreshold) {
                // Stage 1: Just reveal the secondary nav (slide down from behind)
                desktopNav.classList.remove("is-scrolled");
                desktopNav.classList.remove("is-scrolled-deep");
                desktopNav.classList.remove("is-showing-up");
                desktopNav.classList.add("is-revealed");
                showSubnav(lastActiveSubnav);
                desktopNavTop.style.marginTop = "0";
            } else {
                // Back at top
                desktopNav.classList.remove("is-scrolled");
                desktopNav.classList.remove("is-scrolled-deep");
                desktopNav.classList.remove("is-showing-up");
                desktopNav.classList.remove("is-revealed");
                desktopNavTop.style.marginTop = "0";
                if (!desktopNav.matches(":hover")) {
                    hideAllSubnavs();
                }
            }

            lastScrollY = scrollY;
        });

        // Initialize: if already scrolled on page load
        const initialScrollY = window.scrollY;
        if (isHomepage) {
            desktopNav.classList.remove("is-revealed", "is-scrolled");
            if (initialScrollY > stickyThreshold) {
                desktopNav.classList.add("is-scrolled-deep");
                desktopNav.classList.remove("is-showing-up");
                desktopNavTop.style.marginTop = "-" + mainNavHeight + "px";
            } else {
                desktopNav.classList.remove("is-scrolled-deep", "is-showing-up");
                desktopNavTop.style.marginTop = "0";
            }
        } else if (initialScrollY > stickyThreshold) {
            desktopNav.classList.add("is-scrolled");
            desktopNav.classList.add("is-revealed");
            showSubnav(lastActiveSubnav);

            if (initialScrollY > stickyThreshold + mainNavHeight) {
                desktopNav.classList.add("is-scrolled-deep");
                desktopNavTop.style.marginTop = "-" + mainNavHeight + "px";
            } else {
                const slideAmount = Math.min(initialScrollY - stickyThreshold, mainNavHeight);
                desktopNavTop.style.marginTop = "-" + slideAmount + "px";
            }
        } else if (initialScrollY > revealThreshold) {
            desktopNav.classList.add("is-revealed");
            showSubnav(lastActiveSubnav);
        }
    }

    const logoImage = document.querySelector(".main-header .image");
    const triggerSections = document.querySelectorAll(".change-the-logo");

    function updateLogo() {
        let activeSection = null;

        triggerSections.forEach(section => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 120 && rect.top > -rect.height + 120) {
                activeSection = section;
            }
        });
        if (activeSection) {
            logoImage.classList.add("is-active");
        } else {
            logoImage.classList.remove("is-active");
        }
    }

    window.addEventListener("scroll", updateLogo);

    const videos = [
        "https://player.vimeo.com/video/1157515975?h=dc11c74e54&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&loop=1",
        "https://player.vimeo.com/video/1157518038?h=ca485a048a&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&loop=1",
        "https://player.vimeo.com/video/1157518068?h=6dc6731413&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&loop=1",
        "https://player.vimeo.com/video/1157518088?h=8dedac5e80&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&loop=1",
        "https://player.vimeo.com/video/1157518011?h=d62fb5b8f5&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&muted=1&loop=1"
    ];

    const randomIndex = Math.floor(Math.random() * videos.length);
    const videoElement = document.getElementById("randomVideo");
    if (videoElement) {
        videoElement.src = videos[randomIndex];
    }

    if (!tablet.matches) {

        window.addEventListener('scroll', () => {
            const scrollY = window.scrollY;
            const bannerImage = document.querySelector('.article-page .article-banner .background-fixed__media img, .global-section .section-leaders__media img');

            if (bannerImage) {
                // basic safety check for GSAP
                const useGsap = typeof gsap !== "undefined";

                const rect = bannerImage.getBoundingClientRect();
                // rect.top is distance from top of viewport; multiply by a small factor to create parallax
                const y = Math.round(rect.top * 0.2);

                if (useGsap) {
                    gsap.to(bannerImage, {
                        y: y,
                        ease: "none",
                        overwrite: true,
                        duration: 0.45
                    });
                } else {
                    bannerImage.style.transform = `translateY(${y}px)`;
                }
            }
        });
    }

    (() => {
        const header = document.querySelector('.mobile-nav-header');
        if (!header) return;

        let lastY = window.pageYOffset || document.documentElement.scrollTop;
        let ticking = false;

        const THRESHOLD = 5; // px - prevents jitter

        function onScroll() {
            const currentY = window.pageYOffset || document.documentElement.scrollTop;
            const diff = currentY - lastY;

            // Ignore tiny moves to avoid class flicker
            if (Math.abs(diff) < THRESHOLD) return;

            if (diff > 0) {
                // scrolling DOWN
                header.classList.add('is-scrolled');
            } else {
                // scrolling UP
                header.classList.remove('is-scrolled');
            }

            lastY = currentY;
        }

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    onScroll();
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });
    })();
});
